import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LandingPage from "./pages/LandingPage";
import CTSHYLoginPage from "./pages/CTSHYLoginPage";
import DashboardPage from "./pages/DashboardPage";
import FundPage from "./pages/FundPage";
import { Bounce, ToastContainer, toast } from "react-toastify";

import "./App.css";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/ctshy-login" element={<CTSHYLoginPage />} />
        <Route path="/dashboard" element={<DashboardPage />} />
        <Route path="/fund" element={<FundPage />} />
      </Routes>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick={false}
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="dark"
        transition={Bounce}
      />
    </BrowserRouter>
  );
}

export default App;
